import React from "react";
import { toAbsoluteUrl } from "../../../services";

const CountCard = (props) => {
  let { title, count, iconUrl, bgColor } = props;
  return (
    <div className="mb-4 ">
      <div className="flex flex-row">
        <div
          style={{ background: bgColor }}
          className={`2xl:px-10 xl:px-10 lg:px-10  px-4  2xl:py-6 xl:py-6 lg:py-6  rounded-md flex justify-center items-center`}
        >
          <img
            src={toAbsoluteUrl(`/media/nrp/dashboard/${iconUrl}`)}
            alt="icon"
            style={{
              width: "25px",
              height: "25px",
            }}
          />
        </div>
        <div className="ml-4">
          <h4 className="text-[#6F767E] 2xl:text-2xl xl:text-2xl lg:text-xl text-xl   font-medium">
            {title}
          </h4>
          <h4 className="text-[#333333] 2xl:text-2xl xl:text-2xl lg:text-xl text-xl  font-bold">
            {count}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default CountCard;
